import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class PageParamStorageService {
  private _pageParams: Map<string, any> = new Map<string, any>();

  constructor(private router: Router) {}

  get pageParams(): any {
    return this._pageParams[this.currentPath];
  }

  set pageParams(value: any) {
    this._pageParams[this.currentPath] = value;
  }

  private get currentPath(): string {
    if (this.router.url.indexOf('?') !== -1) {
      return this.router.url.substr(0, this.router.url.indexOf('?'));
    } else {
      return this.router.url;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/services/page-param-storage.service.ts